import { selectTrendingPoiIds, fetchTrendingPois, selectTrendingPoiById } from './poisSlice';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PoiList from './PoiList';
import Navbar from '../../app/Navbar';
import { useHistory } from 'react-router-dom';
import '../../stylesheets/TrendingPoisPage.css';


const TrendingPoisPage = () => {
    const poiIds = useSelector(selectTrendingPoiIds);
    const poiStatus = useSelector(state => state.pois.trendingPois.status);
    const error = useSelector((state) => state.pois.trendingPois.error);
    const history = useHistory();
    const goBack = (event) => {
        event.preventDefault();
        history.goBack();
    };
    const dispatch = useDispatch();
    useEffect(() => {
        if (poiStatus === 'idle') {
            dispatch(fetchTrendingPois());
        }
    }, [poiStatus, dispatch]);

    return <div id="search_poi_page">
        <PoiList poiIds={poiIds} status={poiStatus} error={error} onGoBack={goBack} selectById={selectTrendingPoiById} poiType="trending"/>
        <Navbar/>
    </div>
};

export default TrendingPoisPage;